import Vue from "vue";
import Vuetify, {
  VBreadcrumbs,
  VTextField,
  VForm,
  VCarousel,
  VRadioGroup,
  VRadio,
  VSnackbar,
  VBtn
} from "vuetify/lib";
import { Resize } from "vuetify/es5/directives";
import "vuetify/src/stylus/app.styl";

Vue.use(Vuetify, {
  theme: {
    primary: "#f8c12e",
    secondary: "#f8c12e",
    accent: "#f8c12e"
  },
  iconfont: "md",
  components: {
    VTextField,
    VBreadcrumbs,
    VForm,
    VCarousel,
    VRadioGroup,
    VRadio,
    VSnackbar,
    VBtn
  },
  directives: {
    Resize
  }
});
